import { createContext } from "react";

const SelectedThemeContext = createContext({ toggleTheme: () => {} });

export { SelectedThemeContext };
